import axios from 'axios';

export const BASE_URL = 'https://select-gnat-verified.ngrok-free.app'; 

export const MY_URL = 'https://swingeingly-unhydrolized-erminia.ngrok-free.dev'; 

// Flutter의 post 함수를 대체
export const post = async (baseUrl, api, payloadObj, extraHeader = '') => {
  const url = `${baseUrl}${api}`;
  
  // Flutter의 savedToken을 대체할 토큰.
  // 실제 프로젝트에서는 사용자 인증 상태를 관리하는 곳에서 가져와야 합니다.
  const savedToken = localStorage.getItem('authToken'); // 예시: 로컬 스토리지에서 토큰 가져오기
  console.log(savedToken)
  console.log(savedToken != 'undefined' && savedToken != null)

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': savedToken != 'undefined' && savedToken != null ? `Bearer ${savedToken}` : '',
  };

  try {
    const response = await axios.post(url, payloadObj, { headers: headers, timeout: 20000 });
    
    return response.data; // 서버 응답의 data를 반환
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 400) {
          if(extraHeader == 'auth'){
          return error.response.data.detail
          }
      }
      if (!error.response) {
        throw new Error('No Internet connection');
      } else if (error.code === 'ECONNABORTED') {
        throw new Error('API not responded in time');
      } else {
        // HTTP 상태 코드에 따른 에러 처리
        if(error.response.data.detail == 'PROFILE_NOT_FILLED'){
          return 'PROFILE_NOT_FILLED'
        }
        throw new Error(`API Error: ${error.response.status} - ${error.response.statusText}`);
      }
    }
    throw error;
  }
};


export async function get(baseUrl, api, parameters, extraHeader = '') {
  const queryString = new URLSearchParams(parameters).toString();
  const url = `${baseUrl}${api}?${queryString}`;
  const savedToken = localStorage.getItem('authToken');
  try {
  const networkCall = async (token) => {
    return await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      timeout: 20000, // 밀리초 단위 (20초)
    });
  };


    const response = await networkCall(savedToken);
    
    // 이 부분은 Dart 코드의 processResponse 로직에 따라 다르게 구현됩니다.
    // 예를 들어, 응답이 성공적인지 확인하고 데이터를 반환합니다.
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      // 에러 처리
      //return response.status
      throw new Error(`API returned status code ${response.status}`);
    }
  } catch (error) {
    // Dart의 SocketException, TimeoutException 등을 JavaScript의 Axios 에러로 처리
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 404) {
          if(extraHeader != ''){
          return error.response.data.detail
          }
      }

      if (error.code === 'ECONNABORTED') {
        throw new Error('API not responded in time', url);
      } else if (!error.response) {
        throw new Error('No Internet connection', url);
      }
    }
    throw error;
  }
}

export async function PaginatedGet(baseUrl, api, pageKey, pageSize, extraQueryParams = {}) {
  // 1. moodList 처리 및 extraQueryParams 업데이트
  const finalExtraParams = { ...extraQueryParams };

  if (finalExtraParams.mood && Array.isArray(finalExtraParams.mood)) {
    // mood 값이 배열(List<String>)인 경우, 쉼표로 연결된 문자열로 변환합니다.
    finalExtraParams.mood = finalExtraParams.mood.join(',');
  }

  // 2. 최종 쿼리 파라미터 객체 생성 (limit, offset 포함)
  const queryParams = {
    limit: pageSize.toString(),
    offset: pageKey.toString(),
    ...finalExtraParams,
  };

  // 3. 쿼리 스트링 생성 및 URL 조합
  const queryString = new URLSearchParams(queryParams).toString();
  const url = `${baseUrl}${api}?${queryString}`;
  
  // 4. 저장된 토큰 가져오기 (Dart의 userController.authToken 대체)
  const savedToken = localStorage.getItem('authToken');

  const networkCall = async (token) => {
    return await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      timeout: 20000, // 20초 (밀리초 단위)
    });
  };

  try {
    const response = await networkCall(savedToken);

    // Dart의 processResponse 로직을 여기에 구현합니다.
    // 일반적으로 응답 상태를 확인하고 필요한 데이터를 반환합니다.
    if (response.status >= 200 && response.status < 300) {
      return response.data; // 성공 시 응답 데이터 반환
    } else {
      // 서버 응답 오류 처리 (4xx, 5xx)
      throw new Error(`API returned status code ${response.status}: ${response.statusText}`);
    }
    
  } catch (error) {
    // Dart의 SocketException, TimeoutException 등을 JavaScript/Axios 에러로 처리
    
    // 5. TimeoutException 처리 (Axios의 'ECONNABORTED' 코드)
    if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
      throw new Error(`API not responded in time: ${url}`);
    } 
    
    // 6. SocketException (네트워크 연결 끊김) 처리 (응답 객체가 없을 경우)
    if (axios.isAxiosError(error) && !error.response) {
      throw new Error(`No Internet connection: ${url}`);
    }

    // 그 외 일반적인 HTTP/Axios 오류를 다시 throw
    throw error; 
  }
}

export const getWithParams = async (baseUrl, api, parameters) => {
  // Flutter의 Uri(queryParameters: parameters).query를 대체하여 쿼리 문자열 생성
  const queryString = new URLSearchParams(parameters).toString();
  
  // 최종 URL 생성 (쿼리 문자열이 비어있지 않은 경우에만 '?' 추가)
  const url = `${baseUrl}${api}${queryString ? '?' + queryString : ''}`;

  // Flutter의 savedToken을 대체. 
  // 실제 프로젝트에서는 로컬 스토리지, Context 또는 Redux/Zustand 등에서 가져와야 합니다.
  // userController.authToken을 localStorage에서 가져온다고 가정
  const savedToken = localStorage.getItem('authToken'); 

  const headers = {
    'Content-Type': 'application/json',
    // 토큰이 있을 때만 'Bearer' 토큰을 포함
    'Authorization': savedToken ? `Bearer ${savedToken}` : '',
  };

  try {
    // axios.get 요청 (Flutter의 http.get과 동일)
    const response = await axios.get(url, { 
      headers: headers, 
      timeout: 20000 // 20초 타임아웃 설정 (Duration(seconds: 20) 대체)
    });
    
    // Flutter의 processResponse가 백엔드 응답을 처리한다고 가정하고,
    // 여기서는 성공 응답의 .data를 반환합니다.
    return response.data; 

  } catch (error) {
    if (axios.isAxiosError(error)) {
        
      // Flutter의 SocketException 대체 (인터넷 연결 없음)
      if (!error.response && error.code !== 'ECONNABORTED') {
        throw new Error(`FetchDataException: No Internet connection at ${url}`);
      } 
      
      // Flutter의 TimeoutException 대체
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        throw new Error(`ApiNotRespondingException: API not responded in time at ${url}`);
      }
      
      // 기타 HTTP 오류 처리 (4xx, 5xx)
      throw new Error(`API Error ${error.response?.status}: ${error.response?.statusText}`);
    }
    
    // 예상치 못한 오류
    throw error;
  }
};


export async function deleteRequest(baseUrl, api) {
  const url = `${baseUrl}${api}`;
  
  // 1. 토큰 가져오기 (Dart의 userController.authToken 대체)
  const savedToken = localStorage.getItem('authToken');

  const networkCall = async (token) => {
    return await axios.delete(url, {
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      },
      timeout: 20000, // 20초 (밀리초 단위)
    });
  };

  try {
    const response = await networkCall(savedToken);
    
    // Dart의 processResponse는 여기서는 서버 응답 데이터를 반환하는 것으로 가정합니다.
    // (만약 processResponse가 재시도 로직을 포함한다면 해당 로직을 여기에 구현해야 합니다.)
    if (response.status >= 200 && response.status < 300) {
        return response.data; // 성공 응답의 데이터 반환
    } else {
        // HTTP 상태 코드에 따른 추가 처리 (예: 404, 500)
        throw new Error(`Request failed with status ${response.status}`);
    }

  } catch (error) {
    // 2. Dart의 SocketException, TimeoutException 등을 Axios 에러로 처리
    
    if (axios.isAxiosError(error)) {
        // TimeoutException 처리 (Axios의 'ECONNABORTED' 코드)
        if (error.code === 'ECONNABORTED') {
            // throw new ApiNotRespondingException('API not responded in time', url);
            throw new Error(`API not responded in time: ${url}`);
        } 
        // SocketException (네트워크 연결 끊김) 처리 (응답 객체가 없을 경우)
        if (!error.response) {
            // throw new FetchDataException('No Internet connection', url);
            throw new Error(`No Internet connection: ${url}`);
        }
    }
    
    // 그 외 HTTP 오류 (4xx, 5xx)
    throw error;
  }
}


export const toggleDailylookLikes = async (dailylookId) => {
    
    const apiPath = `/v1/dailylooks/${dailylookId}/likes`;
    const url = `${BASE_URL}${apiPath}`;
    
    // 좋아요/언좋아요를 위한 PATCH 요청에는 보통 본문(payload)이 필요 없습니다.
    const payload = null; 
    
    // 인증 토큰은 로컬 스토리지 등에서 가져와야 합니다.
    const savedToken = localStorage.getItem('authToken'); 

    const headers = {
      'Content-Type': 'application/json',
      // 토큰이 있을 때만 'Bearer' 토큰을 포함
      'Authorization': savedToken ? `Bearer ${savedToken}` : '',
    };
    
    try {
        // axios.patch를 사용하여 요청을 보냅니다.
        await axios.patch(url, payload, { headers: headers });
        
        // 요청 성공 (2xx 상태 코드) 시 함수를 종료합니다.
        console.log(`Dailylook ID ${dailylookId} 좋아요 상태 토글 성공`);
        
    } catch (error) {
        // 오류 처리 (네트워크 오류, 4xx, 5xx 응답 등)
        if (axios.isAxiosError(error)) {
            console.error(`좋아요 토글 실패: ${error.response?.status} - ${error.response?.data?.message || error.message}`);
        } else {
            console.error('예상치 못한 오류 발생:', error);
        }
        // 에러를 상위 컴포넌트나 훅으로 전파하여 UI에 표시할 수 있습니다.
        throw error;
    }
};


export async function profileUpdate(

  height, 
  bodyType, 
  image, 
  introduction, 
  receiveChats, 
  publicFashionSense,
  evaluationTarget, 
  instagramId = null // 선택적 인자를 맨 뒤로
) {
  
  const apiPath = `/v1/users/profile`;
  const endpoint = `${BASE_URL}${apiPath}`;
  const savedToken = localStorage.getItem('authToken'); // 로컬 스토리지에서 토큰 가정
  
  // 1. FormData 객체 생성 (Multipart 요청 본문)
  const formData = new FormData();

  // 2. 텍스트 필드 조건부 추가 (Dart의 request.fields 대체)
  if (height !== undefined && height !== null) {
    formData.append('height', height);
  }
  if (bodyType !== undefined && bodyType !== null) {
    formData.append('body_type', bodyType);
  }
  if (introduction !== undefined && introduction !== null) {
    formData.append('introduction', introduction);
  }
  
  // Dart의 bool? 값을 JavaScript의 boolean으로 변환 후 문자열로 추가
  if (receiveChats !== undefined && receiveChats !== null) {
    formData.append('is_receive_chatting_request', receiveChats.toString());
  }
  if (publicFashionSense !== undefined && publicFashionSense !== null) {
    formData.append('is_fashion_sense_public', publicFashionSense.toString());
  }
  
  if (evaluationTarget !== undefined && evaluationTarget !== null) {
    formData.append('evaluation_gender_target', evaluationTarget);
  }
  if (instagramId !== undefined && instagramId !== null) {
    formData.append('instagram_username', instagramId);
  }

  // 3. 파일 필드 조건부 추가 (Dart의 http.MultipartFile.fromPath 대체)
  // File 객체가 유효한지 확인하고 추가
  if (image instanceof File) {
    console.log("image")
    // Axios는 Blob 또는 File 객체를 자동으로 'image' 필드에 추가합니다.
    formData.append('image', image, image.name); 
  }
  // (참고: Flutter의 compressImage 로직은 클라이언트 측에서 별도로 처리되어야 합니다.)


  // 4. Axios 요청 설정
  try {
    const response = await axios.patch(endpoint, formData, {
      headers: {
        // ⭐️ Content-Type: 'multipart/form-data'는 FormData를 사용할 때 Axios가 
        //    자동으로 설정하므로 명시하지 않습니다.
        'Authorization': savedToken ? `Bearer ${savedToken}` : '',
      },
      timeout: 20000,
    });

    // 성공 시 응답 반환
    const responData = response.data


            const userString = JSON.stringify(responData.user); 
    localStorage.setItem('user', userString)
    const newsavedToken = localStorage.getItem('user');
    const storedUserObject = JSON.parse(newsavedToken);

    return true;
    
  } catch (error) {
    // 5. 에러 처리 (네트워크, 타임아웃, HTTP 오류 등)
    if (axios.isAxiosError(error)) {
        if (!error.response) {
            throw new Error(`No Internet connection or API timed out: ${endpoint}`);
        }
        // 4xx, 5xx 에러는 여기서 catch됨
        throw error.response.data || new Error(`API Error: ${error.response.status}`);
    }
    throw error;
  }
}

export async function moodUpdate(
mood
) {
  
  const apiPath = `/v1/users/profile/moods`;
  const endpoint = `${BASE_URL}${apiPath}`;
  const savedToken = localStorage.getItem('authToken'); // 로컬 스토리지에서 토큰 가정
  
  // 1. FormData 객체 생성 (Multipart 요청 본문)


  // (참고: Flutter의 compressImage 로직은 클라이언트 측에서 별도로 처리되어야 합니다.)


  // 4. Axios 요청 설정
  try {
    const response = await axios.patch(endpoint, mood, {
      headers: {
        // ⭐️ Content-Type: 'multipart/form-data'는 FormData를 사용할 때 Axios가 
        //    자동으로 설정하므로 명시하지 않습니다.
        'Authorization': savedToken ? `Bearer ${savedToken}` : '',
      },
      timeout: 20000,
    });

    // 성공 시 응답 반환

                console.log(response)
    return true;
    
  } catch (error) {
    // 5. 에러 처리 (네트워크, 타임아웃, HTTP 오류 등)
    if (axios.isAxiosError(error)) {
        if (!error.response) {
            throw new Error(`No Internet connection or API timed out: ${endpoint}`);
        }
        // 4xx, 5xx 에러는 여기서 catch됨
        throw error.response.data || new Error(`API Error: ${error.response.status}`);
    }
    throw error;
  }
}
